import React from 'react';
import { Link } from "react-router-dom";

function MainPage() {
    return (
        <div className="container-fluid fondo">
            <div className="row carousel-caption" id="carousel2">
                <div className="d-flex justify-content-between animate__animated animate__fadeInDown  mt-5 pt-5 mb-5 pb-5">
                    <div className="col-md-3">
                        <img className="img-fluid" src={require('../Images/logo-slow-food-km0.png')} id="imagen1" alt='logo Slow Food' />
                    </div>
                    <div className="col-md-3 offset-md-5">
                        <img className="img-fluid" src={require('../Images/logo-salta.png')} id="imagen" alt='logo Salta' />
                    </div>
                </div>
                <div className="container-fluid mt-4 pt-4 mb-4 pb-4">
                    <h5 className="text-white text-uppercase animate__animated animate__fadeInDown" id="animation">
                        Slow Food km0 es un proyecto desarrollado entre el Ministerio
                        de Turismo y Deportes de Salta junto a la Red de
                        Organizaciones de Slow Food en Argentina (ROSFA), quienes
                        están encargados de marcar el camino, la filosofía y el
                        protocolo de este concepto.
                    </h5>
                </div>
                <div className="container-fluid animate__animated animate__fadeInDown mt-5 pt-5 mb-5 pb-5" id="animation">
                    <div className="d-flex justify-content-evenly">
                        <Link to="/Novedades" className="btn btn-outline-light py-md-3 px-md-5">Novedades</Link>
                        <a href={require('../Documents/Establecimientos-distinguidos.pdf')} className="btn btn-outline-light py-md-3 px-md-5">Restaurantes Km0</a>
                        <Link to="/Inscripcion" className="btn btn-outline-light py-md-3 px-md-5">Inscripción </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainPage;